var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024.003",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M959.098 64.905c-86.542-86.54-227.348-86.536-313.886 0L11.716 698.4C4.288 705.826.082 716 .014 726.414c0 .092-.014.182-.014.274v257.31C0 1006.09 17.91 1024 40.004 1024h257.31c10.4 0 20.726-4.155 28.288-11.717l633.496-633.498c86.536-86.536 86.536-227.342 0-313.88zM80.008 943.993V823.267l120.728 120.726H80.008zm217.306-16.57L96.578 726.687 596.416 226.85l72.08 72.08-268.65 268.65c-15.624 15.623-15.624 40.95 0 56.575 15.622 15.622 40.952 15.624 56.576 0l268.65-268.65 72.08 72.078-499.838 499.84zm605.208-605.21l-48.796 48.796-200.734-200.735 48.798-48.796c55.344-55.345 145.394-55.34 200.734 0 55.342 55.34 55.342 145.39-.002 200.733z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.c7e280ddc86f19910dfda69eca397863.svg";
export { ForwardRef as ReactComponent };